module.exports = __webpack_public_path__ + "img/10.d3c0c742.jpg";